import {
  NumberType,
  PhoneType,
} from "@redotech/redo-model/support/phone/phone-types";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { object, string } from "zod/v4";
export const setupPhoneNumber = {
  name: "setupPhoneNumber" as const,
  input: object({
    phoneNumber: string(),
    phoneType: createEnum(PhoneType),
    numberType: createEnum(NumberType),
    termsOfUseUrl: string().optional(),
    privacyPolicyUrl: string().optional(),
  }),
  output: object({}),
};

export type SetupPhoneNumberInput = z.infer<typeof setupPhoneNumber.input>;
export type SetupPhoneNumberOutput = z.infer<typeof setupPhoneNumber.output>;
